import { get } from 'lodash';
import * as Constants from '../../constants';

const resetState = {
  isError: false,
  errors: [],
  isKeyStoreSaveSuccess: false,
  isProxyUpdateSuccess: false,
  isKeyStoreDeleteSuccess: false,
};
const initialState = {
  ...resetState,
  isLoading: false,
  keyStoreDetails: {},
  keyStoreDetailsKeyCounts: {},
  keyStoreList: {
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  proxies:{
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  keyStoreProxies:{
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  keyDeployments:{
    totalPages: 1,
    totalElements: 0,
    results: [],
  },
  isKeyStoreDeleteSuccess: false,
  isKeyStoreBulkDeploymentSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case Constants.APP_RESET:
      return {
        ...state,
        ...resetState,
      };
    case Constants.APP_RESET_KEY_STORE:
      return {
        ...state,
        ...resetState,
        keyStoreDetails: {},
      };
    case Constants.KEY_STORE_DETAILS_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        keyStoreDetails: action.payload,
        isKeyStoreSaveSuccess: false,
        isKeyStoreDeleteSuccess: false,
      };
    case Constants.KEY_STORE_DETAILS_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isKeyStoreDeleteSuccess: false,
      };
      case Constants.KEY_STORE_DETAILS_KEY_COUNTS_GET_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: [],
          keyStoreDetailsKeyCounts: action.payload,
          isKeyStoreBulkDeploymentSuccess: false,
        };
      case Constants.KEY_STORE_DETAILS_KEY_COUNTS_GET_ERROR:
        return {
          ...state,
          isError: true,
          isLoading: false,
          errors: action.payload,
        };
    case Constants.KEY_STORE_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        keyStoreList: action.payload,
        isKeyStoreDeleteSuccess: false,
      };
    case Constants.KEY_STORE_LIST_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isKeyStoreDeleteSuccess: false,
      };
    case Constants.KEY_STORE_DETAILS_PROXIES_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        proxies: action.payload,
      };
    case Constants.KEY_STORE_DETAILS_PROXIES_LIST_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        keyDeployments: action.payload,
      };
    case Constants.KEY_STORE_KEY_DEPLOYMENTS_LIST_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.KEY_STORE_OVERVIEW_PROXIES_LIST_GET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        keyStoreProxies: action.payload,
      };
    case Constants.KEY_STORE_OVERVIEW_PROXIES_LIST_GET_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
      };
    case Constants.KEY_STORE_SAVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        keyStoreDetails: action.payload,
        isKeyStoreSaveSuccess: true,
      };
    case Constants.KEY_STORE_SAVE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isKeyStoreSaveSuccess: false,
      };
    case Constants.KEY_STORE_PROXY_UPDATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isProxyUpdateSuccess: true,
      };
    case Constants.KEY_STORE_PROXY_UPDATE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isProxyUpdateSuccess: false,
      };
    case Constants.KEY_STORE_DELETE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        errors: [],
        isKeyStoreDeleteSuccess: true,
      };
    case Constants.KEY_STORE_DELETE_ERROR:
      return {
        ...state,
        isError: true,
        isLoading: false,
        errors: action.payload,
        isKeyStoreDeleteSuccess: false,
      };
      case Constants.KEY_STORE_KEY_BULK_DEPLOYMENTS_SUCCESS:
        return {
          ...state,
          isLoading: false,
          isError: false,
          errors: [],
          isKeyStoreBulkDeploymentSuccess: true,
        };
      case Constants.KEY_STORE_KEY_BULK_DEPLOYMENTS_ERROR:
        return {
          ...state,
          isError: true,
          isLoading: false,
          errors: action.payload,
          isKeyStoreBulkDeploymentSuccess: false,
        };
    default:
      return state;
  }
}

export const getIsLoading = (state) => get(state, 'keyStore.isLoading');

export const getIsError = (state) => get(state, 'keyStore.isError');

export const getErrors = (state) => get(state, 'keyStore.errors');

export const getIsKeyStoreSaveSuccess = (state) => get(state, 'keyStore.isKeyStoreSaveSuccess');

export const getKeyStoreDetails = (state) => get(state, 'keyStore.keyStoreDetails');
export const getKeyStoreDetailsKeyCounts = (state) => get (state, 'keyStore.keyStoreDetailsKeyCounts');

export const getIsProxyUpdateSuccess = (state) => get(state, 'keyStore.isProxyUpdateSuccess');

export const getProxyListResults = (state) => get(state, 'keyStore.proxies.results');
export const getProxyListTotalElements = (state) => get(state, 'keyStore.proxies.totalElements');
export const getProxyListTotalPages = (state) => get(state, 'keyStore.proxies.totalPages');

export const getKeyStoreListResults = (state) => get(state, 'keyStore.keyStoreList.results');
export const getKeyStoreListTotalElements = (state) => get(state, 'keyStore.keyStoreList.totalElements');
export const getKeyStoreListTotalPages = (state) => get(state, 'keyStore.keyStoreList.totalPages');

export const getIsKeyStoreDeleteSuccess = (state) => get(state, 'keyStore.isKeyStoreDeleteSuccess');

export const getKeyStoreProxyListResults = (state) => get(state, 'keyStore.keyStoreProxies.totalElements');

export const getKeyDeploymentsListResults = (state) => get(state, 'keyStore.keyDeployments.results');
export const getKeyDeploymentsListTotalElements = (state) => get(state, 'keyStore.keyDeployments.totalElements');
export const getKeyDeploymentsListTotalPages = (state) => get(state, 'keyStore.keyDeployments.totalPages');

export const getIsKeyStoreBulkDeploymentSuccess = (state) => get(state, 'keyStore.isKeyStoreBulkDeploymentSuccess');